<script>
import MultiSelect from './MultiSelect.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: MultiSelect, // End of Component > extends
    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            defaultValue: null,
        }
    },
    computed: {
        /**
         * format the ISD Codes list as required
         *
         * @return {void}
         */
        formatOptions() {
            const key = this.$store.getters.getField(this.field.key)
            if (!key) {
                if (!this.defaultValue) {
                    if (
                        this.options &&
                        this.options.length &&
                        this.options.length > 0
                    ) {
                        const index = this.options.findIndex((e) => {
                            if (e.isdCode == '+92') {
                                return true
                            }
                        })
                        this.defaultValue = this.options[index]
                        this.writeValue(this.defaultValue)
                    }
                }
            } else {
                const current = this.value
                const isCurrentSelectionStillValid =
                    current &&
                    (current._id == key || current.isdCode == key)

                if (
                    !isCurrentSelectionStillValid &&
                    this.options &&
                    this.options.length &&
                    this.options.length > 0
                ) {
                    const index = this.options.findIndex((e) => {
                        if (e._id == key || e.isdCode == key) {
                            return true
                        }
                    })

                    this.defaultValue = this.options[index]
                    this.writeValue(this.defaultValue)
                }
            }

            return this.options.map((option) => {
                return {
                    isdCode: option.isdCode,
                    isdCodeTitle: `${option.isdCode} (${option.title})`,
                    _id: option._id,
                }
            })
        }, // End of formatOptions() method
        model: {
            /**
             * Getter to get value for computed property
             * using props from parent componennt
             *
             * @return {mix}
             */
            get: function () {
                
                return this.value
            }, // End of get() method
            /**
             * Setter to set value for computed property
             * notifying the parent component
             *
             * @return {void}
             */
            set: function (newValue) {
                this.value = newValue
                this.$store.commit('updateField', {
                    key: this.field.key,
                    value: newValue.isdCode,
                })
                // this.$store.commit('updateField', {
                //     key: "contactInfo.countryCodeForCodeOnly",
                //     value: newValue,
                // })
            }, // End of set() method
        },
    }, // End of Component > computed

    mounted() {},

    methods: {
        /*
        |--------------------------------------------------------------------------
        | Manually setting the value of Dropdown
        |--------------------------------------------------------------------------
        */
        writeValue(newValue) {
            this.value = newValue
        //   console.log(newValue)
            if (this.field.isLocked) {
                this.$store.commit('updateField', {
                    key: this.field.key,
                    value: newValue.isdCode ? newValue.isdCode : '',
                })
            }
        }, // End of Method > writeValue
    }, // End of Component > mounted
}
</script>
